import { useEffect, useRef, useState } from "react";
import { LOADING_MESSAGES } from "../data/loadingMessages";

const LOADING_MESSAGE_INTERVAL_MS = 7000;

/**
 * Rotates through a message array every 7s while `active` is true. Uses an
 * index ref so the cursor survives re-renders and always advances by one
 * (legacy parity with `art_of_the_day-v2.tsx` lines 553–563). `messages`
 * defaults to the AOTD `LOADING_MESSAGES`; pass a different array (e.g. the
 * card-drop set) to reuse the same rotation feel elsewhere.
 */
export function useLoadingMessages(
  active: boolean,
  messages: readonly string[] = LOADING_MESSAGES,
): string {
  const indexRef = useRef<number>(Math.floor(Math.random() * messages.length));
  const [message, setMessage] = useState<string>(() => messages[indexRef.current]);

  useEffect(() => {
    if (!active || messages.length === 0) return;
    setMessage(messages[indexRef.current % messages.length]);
    const id = setInterval(() => {
      indexRef.current = (indexRef.current + 1) % messages.length;
      setMessage(messages[indexRef.current]);
    }, LOADING_MESSAGE_INTERVAL_MS);
    return () => clearInterval(id);
  }, [active, messages]);

  return message;
}
